import PropTypes from "prop-types";

export const RootType = {
	children: PropTypes.node.isRequired,
	style: PropTypes.any
};
